export default __webpack_public_path__ + "static/media/poligon.a103f777.svg";